<template>
    <div class="Earnings">
        <v-container fluid class="pt-0">
          <v-card class="no-shadow pa-2 card-r">

          <v-toolbar class="primary card-r pl-3 text-white">
            <div class="text-xs-left f-20">Earnings</div>
          </v-toolbar>
          <v-container fluid grid-list-xl class="text-xs-center pa-0 mt-3">
            <v-layout row wrap class="Content3">

              <v-flex d-flex lg4 sm6 xs12>
                <v-card class="card-r tranprant boxShadow b-border text-green pa-3 " flat  xs12>
                  <!--<v-card class="card-r no-shadow green accent-4 white&#45;&#45;text pa-3 " flat  xs12>-->
                  <br>
                  <!--<v-icon class="white&#45;&#45;text">fas fa-money-check</v-icon>-->
                  <v-icon class="text-primary f-40">fas fa-money-check</v-icon>
                  <p class="mt-0 mb-0 text-xs-center font-weight-medium text-primary">Income</p>
                  <span class="text-primary display-0.75 text-xs-center headline font-weight-bold">Kr {{earningtot.total_deposit}} </span>

                </v-card>

              </v-flex>
              <v-flex d-flex lg4 sm6 xs12>
                <v-card class="card-r tranprant boxShadow r-border text-green pa-3 " flat  xs12>
                  <!--<v-card class="card-r no-shadow green accent-4 white&#45;&#45;text pa-3 " flat  xs12>-->
                  <br>
                  <!--<v-icon class="white&#45;&#45;text">fas fa-money-check</v-icon>-->
                  <v-icon class="text-red f-40">fas fa-money-check</v-icon>
                  <p class="text-red mt-0 mb-0 text-xs-center font-weight-medium">Outcome</p>
                  <span class="text-red display-0.75 text-xs-center headline font-weight-bold">Kr {{earningtot.total_withdraw}}  </span>
        
                </v-card>

              </v-flex>
              <v-flex d-flex lg4 sm6 xs12>
                <v-card class="card-r tranprant boxShadow g-border text-green pa-3 " flat  xs12>
                  <!--<v-card class="card-r no-shadow green accent-4 white&#45;&#45;text pa-3 " flat  xs12>-->
                  <br>
                  <!--<v-icon class="white&#45;&#45;text">fas fa-money-check</v-icon>-->
                  <v-icon class="text-green f-40">fas fa-money-check</v-icon>
                  <p class="text-green mt-0 mb-0 text-xs-center font-weight-medium">Balance</p> 
                  <span class="text-green display-0.75 text-xs-center headline font-weight-bold">Kr {{earningtot.total_balance}} </span>

                </v-card>

              </v-flex>
            </v-layout>
          </v-container>
          </v-card>

  
          <div class="table2 mt-3 card-r">
                <!--<p class="textColor font-weight-black display-1 text-md-center">Earnings</p>-->
                <TableWithoutView v-if="loading===false" :headers="headers" :items="this.earningData" :pagination="pagination"></TableWithoutView>
            </div>
        </v-container>

        <!-- <notifications group="error" position="bottom center"/>
        <notifications group="Success" position="bottom center"/> -->

    </div>
</template>
<script>
    /* eslint-disable */
    import TableWithoutView from "@/components/TableWithoutView.vue";
    import SearchPanel from "@/components/SearchPanel.vue";
    import notifications from "@/components/SearchPanel.vue";
    import { mapState } from "vuex";

    export default {
        name: "Earnings",
        data: () => ({

            selected: [],
            headers: [
                {text: "Date", value: 'date'},
                {text: "Payee", value: 'payee_name'},
                {text: "Payer", value: 'payer_name'},
                {text: "Deposit", value: 'deposit'},
                {text: "withdraw", value: 'withdraw'},
                {text:"Balance",value:'balance'},
                // {text:"Amount",value:'deposit'},
            ],

        }),
        methods: {},
        created: function () {
            Store.dispatch('getAllEarnings')
            Store.dispatch("getEarningsTotalAmount");
            //this.earningData = Store.state.earningData;
        },

        /*mounted() {
            axios
                .get('https://api.coindesk.com/v1/bpi/currentprice.json')
                .then(response => {
                    this.info = response.data.bpi
                })
                .catch(error => {
                    this.error = true
                })
                .finally(() => this.loading = false)
        },*/
        mounted() {

        },

        computed:{
            ...mapState({
                earningData: "earningData",
                pagination: "pagination",
                loading: "loading",
                mode: "mode",
                earningtot: "earningtot"
                
                // snackbar: "snackbar",
                // notice: "notice"
            }),
        },
        components:{
			   TableWithoutView,
            SearchPanel,
            notifications
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/pages/Earnings.vue